<template>
  <el-dialog title="批量设置库存" :visible.sync="dialogVisible" width="500px" @close="handleClose">
    <div style="padding: 20px;">
      库存数量：
      <el-input-digit v-model.number="value" clearable style="width: 160px;" />
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleOk">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      opts: {},
      value: 0,
    };
  },

  methods: {
    method_open(opts) {
      this.opts = opts;
      this.dialogVisible = true;
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data());
    },
    handleOk() {
      if (!this.value) {
        return this.$message.warning('请设置库存！');
      }
      this.opts.okFn && this.opts.okFn(this.value);
      this.handleClose();
    },
  },
};
</script>
